module.exports = __webpack_public_path__ + "icon-adobe-em.xiz0gjpj.svg";